// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import { PageNotFound } from '../common';
import { ManageSubs, MaintainAccounts, ManageOuts, ManageSubstitutions, AdminConsole, CustomerGroup, ManageAccountsAuditTrail, ManageOutsAuditTrail, SubRepositoriesAuditTrail, CreateGroupsAuditTrail, OgmSubs } from './';

export default {
  path: 'manage-subs',
  component: ManageSubs,
  childRoutes: [
    {
      path: 'maintain-accounts',
      component: MaintainAccounts,
    }, {
      path: 'manage-outs',
      component: ManageOuts,
      isIndex: true,
    }, {
      path: 'sub-repositories',
      component: ManageSubstitutions,
    }, {
      path: 'admin-console',
      component: AdminConsole,
    }, {
      path: 'manage-groups',
      component: CustomerGroup,
    }, 
    {
      path: 'manage-accounts-audit-trail',
      component: ManageAccountsAuditTrail,
    },
    {
      path: 'manage-outs-audit-trail',
      component: ManageOutsAuditTrail,
    },
    {
      path: 'sub-repositories-audit-trail',
      component: SubRepositoriesAuditTrail,
    }, 
    {
      path: 'create-groups-audit-trail',
      component: CreateGroupsAuditTrail,
    },
    {
      path: 'ogm-subs',
      component: OgmSubs,
    },
    { path: '*', component: PageNotFound },//COT-9353: SIA+ Screen refresh issue. handle incorrect path,must keep this as last path,otherwise it will match all path,otherwise it will match all path
  ],
};
